<template>
  <label class="select-box" :class="{ withIcon: $slots.icon, error }">
    <select required v-bind="$attrs" :value="value" v-on="changeListeners">
      <!-- @slot `<option>` での指定 -->
      <slot />
      <option v-for="item in list" :key="item.key" :value="item.key" :selected="`${value}` === `${item.key}`">{{
        item.label
      }}</option>
    </select>
    <!-- @slot icon アイコン -->
    <span v-if="$slots.icon" class="icon">
      <slot name="icon" />
    </span>
  </label>
</template>

<script>
/**
 * セレクトボックス
 */

import { isMap } from 'lodash'

export default {
  name: 'SelectBox',
  inheritAttrs: false,
  model: {
    props: 'value',
    event: 'change',
  },
  props: {
    /** 値 */
    value: [String, Number],
    /** 選択肢 */
    items: [Object, Array, Map],
    /** エラー表示 */
    error: Boolean,
  },
  computed: {
    list() {
      if (isMap(this.items)) return Array.from(this.items).map(([key, label]) => ({ key, label }))
      if (this.items instanceof Array) return this.items.map((value, index) => ({ key: index, label: value }))
      if (this.items instanceof Object) return Object.keys(this.items).map(key => ({ key, label: this.items[key] }))
      return this.items
    },
    changeListeners() {
      return {
        ...this.$listeners,
        change: e => {
          this.$emit('change', e.target.value)
        },
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.select-box {
  display: inline-block;
  position: relative;

  &::after {
    border: 5px solid transparent;
    border-left: 5px solid #757575;
    box-sizing: border-box;
    content: '';
    height: 5px;
    pointer-events: none;
    position: absolute;
    right: 16px;
    top: 18px;
    transform: rotate(90deg);
    width: 5px;
  }

  select {
    appearance: none;
    background-color: var(--white);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    box-sizing: border-box;
    color: var(--text-color);
    cursor: pointer;
    font-size: 15px;
    height: 40px;
    margin: 0;
    outline: 0;
    padding: 0 36px 0 16px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    width: 100%;

    &:invalid {
      color: var(--dark-gray);

      option {
        color: var(--text-color);
      }
    }

    .sp & {
      @media screen and (--sp-modal) {
        &:invalid {
          color: var(--light-gray);
        }
      }
    }

    &:disabled {
      background-color: var(--mostly-white-1);
      cursor: default;
    }
  }

  &.withIcon select {
    padding-left: 40px;
  }

  &.error select {
    background: #fff3f0;
    border-color: var(--pure-red);
  }
}

.icon {
  fill: var(--very-dark-gray-2);
  left: 8px;
  pointer-events: none;
  position: absolute;
  top: 8px;

  :invalid ~ & {
    fill: var(--light-gray);
  }
}
</style>
